import { ButtonPrimary } from '@/shared/ui/button';
import styles from './index.module.sass';
import { IMixingRecipeRoot } from '@/widgets/recipe/types';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useStore } from 'effector-react';
import { $selectedMix } from '@/modules/mixing/store/recipes.store';
import { createMixOfferFoo } from './create-mix-offer.function';
import { notification } from 'antd';
import { $topRecipesForWarehouse } from '@/widgets/recipe/model';

export const TotalCardBadge = ({
  data,
  totalData,
  weight,
  profit,
  price,
}: ITotalCardBadge) => {
  const [params] = useSearchParams();
  const bunkers = params.get('bunker');
  const selectedMix = useStore($selectedMix);
  const topRecipesData = useStore($topRecipesForWarehouse);
  const navigate = useNavigate();
  const ifViewOnly = !!(params.get('viewOnly'));

  console.log(selectedMix)

  return (
    <div className={styles.root}>
      <div className={styles.topData}>
        <span>итог</span>
        <div className={styles.weight}>
          вес
          <div className={styles.weightBadge}>{weight.toFixed(1)} т</div>
        </div>
      </div>
      <div className={styles.midData}>
        <div className={styles.spec}>
          <span className={styles.specName}>клейковина</span>
          <span className={styles.specVal}>{data.gluten}</span>
          <span className={styles.specSign}>%</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>влажность</span>
          <span className={styles.specVal}>{data.humidity}</span>
          <span className={styles.specSign}>%</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>ИДК</span>
          <span className={styles.specVal}>{data.idk}</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>число падения</span>
          <span className={styles.specVal}>{data.cp}</span>
          <span className={styles.specSign}>сек</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>протеин</span>
          <span className={styles.specVal}>{data.protein}</span>
          <span className={styles.specSign}>кДа</span>
        </div>
        <div className={styles.spec}>
          <span className={styles.specName}>натура</span>
          <span className={styles.specVal}>{data.nature}</span>
          <span className={styles.specSign}>г/л</span>
        </div>
      </div>
      <div className={styles.bottomData}>
        <span className={styles.profit}>
          выгода
          <span className={styles.val}>
            {' '}
            +{' '}
            {Number(profit)?.toLocaleString('RU-ru', { maximumFractionDigits: 0 }) ||
              0}{' '}
            ₽
          </span>
        </span>
        <span className={styles.price}>
          стоимость
          <span className={styles.val}>
            {Number(price)?.toLocaleString('RU-ru', { maximumFractionDigits: 0 }) || 0}{' '}
            ₽
          </span>
        </span>
      </div>
      { !ifViewOnly && <div className={styles.actions}>
        <ButtonPrimary
          label={'использовать'}
          onClick={async () => {
            if (selectedMix && bunkers) {
              await createMixOfferFoo(
                { ...selectedMix, bunkerreloaders_ids: JSON.parse(bunkers) },
                'mix',
                topRecipesData?.mix_signature,
              );
              navigate('/mixing/recipes-new?active_tab=1');
            } else {
              notification.error({
                message: 'Что-то пошло не так. Выбранный микс не найден',
              });
            }
          }}
          className={styles.action}
        />
      </div>}
    </div>
  );
};

interface ITotalCardBadge {
  data: {
    gluten: number;
    idk: number;
    protein: number;
    humidity: number;
    cp: number;
    nature: number;
  };
  totalData: IMixingRecipeRoot;
  weight: number;
  profit: number;
  price: number;
}
